export const parties = ['Tenant', 'Vendor', 'Customer'] as const
export type Party = (typeof parties)[number]
